import React from "react";
import { Link, Outlet, useLoaderData, useOutlet, useRouteLoaderData } from "react-router-dom";

import * as APIMEJORATE from "../services/mejorate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }

  const data = await APIMEJORATE.getAllMejorateByTax(params.tratamientoId);
  //const data = await APIMEJORATE.getAllMejorate();

  let firstCannabis = null;
  let firstAlcohol = null;
  let firstCocaina = null;
  let firstBenzo = null;

  for (const item of data) {
    const type = item.meta?.mejorateTipo;
    if (type === "Cannabis" && !firstCannabis) firstCannabis = item;
    if (type === "Alcohol" && !firstAlcohol) firstAlcohol = item;
    if (type === "Cocaína" && !firstCocaina) firstCocaina = item;
    if (type === "Benzodiazepinas" && !firstBenzo) firstBenzo = item;

    // Si ya encontramos los cuatro, podemos romper el bucle
    if (firstCannabis && firstAlcohol && firstCocaina && firstBenzo) break;
  }

  return {
    data,
    firstCannabis,
    firstAlcohol,
    firstCocaina,
    firstBenzo
  };
}

export default function MejorateList() {
  const outlet = useOutlet();
  const { data, firstCannabis, firstAlcohol, firstCocaina, firstBenzo } = useLoaderData(); // Cargar datos del loader
  console.log({ data, firstCannabis, firstAlcohol, firstCocaina, firstBenzo });
  // Función para determinar el mensaje y botón
  const renderMejorateStatus = (item) => {
    if (item?.meta?.mejorateCompleted) {
      return (
        <>
          <p className="mejorate-item__result-claim">Porcentaje de aciertos:</p>
          <p className="mejorate-item__result-perc">
            {item.meta.mejorateStep > 0 
              ? ((item.meta.mejoratePoint || 0) / item.meta.mejorateStep * 100).toFixed(2) 
              : 0}%
          </p>
          <button className="button is-link is-outlined mt-2">Volver a hacer el cuestionario</button>
        </>
      );
    } else if (item?.meta?.mejorateStep) {
      return (
        <button className="button is-link">Continuar cuestionario</button>
      );
    } else {
      return (
        <button className="button is-link">Hacer el cuestionario</button>
      );
    }
  };

  return (
    <>
      {outlet ? (
        outlet
      ) : (
        <div id="content" className="full">
          {data?.length > 0 ? (
            <ul className="mejorate-container">
              {firstAlcohol && (
                <li>
                  <Link to="../alcohol" className="mejorate-item">
                    <p className="mejorate-item__title">
                      El Alcohol y<br /> tu Cuerpo
                    </p>
                    <div className="mejorate-item__result">
                      {renderMejorateStatus(firstAlcohol)}
                    </div>
                  </Link>
                </li>
              )}
              {firstCocaina && (
                <li>
                  <Link to="../cocaina" className="mejorate-item">
                    <p className="mejorate-item__title">
                      La Cocaína y<br /> tu Cuerpo
                    </p>
                    <div className="mejorate-item__result">
                      {renderMejorateStatus(firstCocaina)}
                    </div>
                  </Link>
                </li>
              )}
              {firstBenzo && (
                <li>
                  <Link to="../benzodiazepina" className="mejorate-item">
                    <p className="mejorate-item__title">
                      Las Benzodiazepinas y<br /> tu Cuerpo
                    </p>
                    <div className="mejorate-item__result">
                      {renderMejorateStatus(firstBenzo)}
                    </div>
                  </Link>
                </li>
              )}
              {firstCannabis && (
                <li>
                  <Link to="../cannabis" className="mejorate-item">
                    <p className="mejorate-item__title">
                      El Cannabis y<br /> tu Cuerpo
                    </p>
                    <div className="mejorate-item__result">
                      {renderMejorateStatus(firstCannabis)}
                    </div>
                  </Link>
                </li>
              )}
            </ul>
          ) : (
            <div className="no-cuestionario">
              <h2>No existen cuestionarios disponibles para completar</h2>
            </div>
          )}
        </div>
      )}
    </>
  );
}
